import SwimlaneScheduleModal from './SwimlaneScheduleModal';

export default SwimlaneScheduleModal;
